import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  password: Yup.string()
  .required('Ingresa una contraseña.'),
  token: Yup.string()
    .required('Token inválido.')
});
